import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://api.korchem.cz/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 2,
    "name": "Český jazyk",
    "locale": "cs",
    "image": {
      "id": 2,
      "name": "cz.svg",
      "url": "https://api.korchem.cz/files/cz.svg?ai=0",
      "custom_title": "cz",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 3,
      "name": "gb.svg",
      "url": "https://api.korchem.cz/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 9,
    "name": "Italský jazyk",
    "locale": "it",
    "image": {
      "id": 9,
      "name": "it.svg",
      "url": "https://api.korchem.cz/files/it.svg?ai=0",
      "custom_title": "it",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
